import { createSlice } from '@reduxjs/toolkit';

export interface UserdataModel {
  username: string;
  // Greeting name, split from the token's "LASTNAME, FIRSTNAMES" full name
  firstName?: string;
  userId: string;
  dni?: string;
  otpCode?: string;
  changeHash?: string;
}

const initialState: UserdataModel = {
  username: '',
  userId: '',
};

export const userdataSlice = createSlice({
  name: 'userdata',
  initialState,
  reducers: {
    pushUserdata: (state, action: { payload: UserdataModel }) => ({
      ...state,
      ...action.payload,
    }),
    pushUserDocument: (state, action: { payload: string }) => ({
      ...state,
      dni: action.payload,
    }),
    pushOtpCode: (state, action: { payload: string }) => ({
      ...state,
      otpCode: action.payload,
    }),
    pushChangeHash: (state, action: { payload: string }) => ({
      ...state,
      changeHash: action.payload,
    }),
    resetUserdata: () => initialState,
  },
});

export const { pushUserdata, pushUserDocument, pushOtpCode, pushChangeHash, resetUserdata } = userdataSlice.actions;

export default userdataSlice.reducer;
